exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.css);", ""]);

// module
exports.push([module.id, "label { font-size: 2em; }\n\ninput[type=checkbox] { display:none; }\n\ninput[type=checkbox] + label:before {\n  font-family: FontAwesome;\n  display: inline-block;\n}\n\ninput[type=checkbox] + label:before { content: \"\\F096\"; }\n\ninput[type=checkbox] + label:before { letter-spacing: 10px; }\n\ninput[type=checkbox]:checked + label:before { content: \"\\F046\"; }\n\ninput[type=checkbox]:checked + label:before { letter-spacing: 5px; }\n\n._3LHwA9MTHqqQHJ-88sQrX8 {\n  position: absolute;\n  z-index: 999;\n  background-color: rgba(255, 255, 255, 0.93);\n  left: 10%;\n  border: 2px solid whitesmoke;\n  display: inline-block;\n  padding-left: 4em;\n  padding-right: 4em;\n  padding-bottom: 3em;\n  padding-top: 1.7em;\n  border-radius: 3px;\n  margin: 2em;\n}\n\n._3LHwA9MTHqqQHJ-88sQrX8 h1 {\n  font-size: 2.5em;\n}\n\n._3fcLZWOmqlAvLfEsPlANyj {\n  margin-bottom: .5em;\n}", ""]);

// exports
exports.locals = {
	"guestList": "_3LHwA9MTHqqQHJ-88sQrX8",
	"guestName": "_3fcLZWOmqlAvLfEsPlANyj"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/postcss-loader!./src/styles/guest-list.css
// module id = 127
// module chunks = 0